require('./thumbnail-selector/thumbnail-selector.scss');
var ThumbnailItem = require('./thumbnail-selector/thumbnail-item');
var ThumbnailSelector = Marionette.CollectionView.extend({
    className: 'fmcy-thumbnail-selector row-flex clearfix',
    childView: ThumbnailItem,
    childEvents: {
        'thumb:clicked': 'onChildThumbClicked'
    },
    onChildThumbClicked: function(childView) {
        this.trigger('thumb:clicked', childView.model, this.options.collection);
        this.resetItemsSelected();
        childView.setActive();
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                thumbStyle: 'thumbs',
                theme: 'light', // light, dark
                alignment: 'vertical'
            }
        );

        var SlideCollection = Backbone.Collection.extend({
          comparator: function (a) {
            if (a.get('is_primary') === '1') {
                return -1;
            } else {
                return 1;
            }
          }
        });

        this.collection = new SlideCollection(this.collection.toJSON());
    },
    resetItemsSelected: function () {
      var self = this;
      this.collection.each(function(model) {
        var view = self.children.findByModel(model);
        if (view) {
            view.reset();
        }
      });
    },
    childViewOptions: function(model, index) {
        var extraClassName = 'col-flex-xs-12';
        if (model.get('is_primary') === '1') {
          extraClassName += ' thumbnail-item-selected';
        }
        return {
            collection: this.options.collection,
            extraClassName: extraClassName
        };
    },
    onRender: function() {
        this.$el.addClass(this.options.thumbStyle);
    }
});
module.exports = ThumbnailSelector;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-item-expanded/thumbnail-selector.js
 **/